import { SWITCH_THEME } from "./constants";

const initialState = {
  theme: "dark"
};

export default (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case SWITCH_THEME:
      return {
        theme: state.theme === "dark" ? "light" : "dark"
      };

    default:
      return state;
  }
};
